import {
  FormControl,
  FormLabel,
  Box,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";
import { ChangeEventDatePicker } from "../../../core/models/bills/bills.model";
import {
  DatePickersData,
  Filters,
} from "../../../core/models/datePickersComponent/datePickersComponent.model";
import "./DatePickersComponent.scss";
import { useTranslation } from "react-i18next";

interface DatePickersComponentProps {
  filters: Filters;
  setFilters: (id: keyof Filters, value: ChangeEventDatePicker | null) => void;
  justifyContent?: string;
  billsSearchBar?: boolean;
  customTitle?: string;
  required?: boolean;
  noWrap?: boolean;
  enableFuture?: boolean;
  label?: string;
}

const DatePickersComponent = ({
  filters,
  setFilters,
  justifyContent = "space-between",
  billsSearchBar,
  customTitle,
  required,
  noWrap,
  enableFuture,
  label,
}: DatePickersComponentProps) => {
  const { t } = useTranslation();
  const isDesktopViewport = useMediaQuery("(min-width:744px)");
  const datePickersData: DatePickersData[] = [
    { id: "dateFrom", label: "Fecha inicio", minDate: false },
    {
      id: "dateTo",
      label: "Fecha fin",
      minDate: true,
    },
  ];   

  return (
    <FormControl
      className="form-stack"
      sx={{
        display: "flex",
        gap: ".85rem",
      }}
    >
      {!customTitle ? (
        <FormLabel>
          <Typography fontWeight={600}>
            {t(`Tablas.${label ? label : "Periodo de facturación"}`)}
            {required && (
              <Typography component={"span"} color={"red"}>
                {" "}
                *{" "}
              </Typography>
            )}
          </Typography>
        </FormLabel>
      ) : (
        <FormLabel>
          <Typography fontWeight={600}>
            {t(customTitle)}
            {required && (
              <Typography component={"span"} color={"red"}>
                {" "}
                *{" "}
              </Typography>
            )}
          </Typography>
        </FormLabel>
      )}

      <Box
        width={`${billsSearchBar || noWrap ? "100%" : "auto"}`}
        className="datepicker-wrapper"
        component="section"
        display="flex"
        justifyContent={isDesktopViewport ? justifyContent : "flex-start"}
        alignItems="center"
        flexWrap={`${billsSearchBar || noWrap ? "nowrap" : "wrap"}`}
        gap={isDesktopViewport ? "0.5rem" : "1rem"}
      >
        {datePickersData.map(({ id, label, minDate }) => (
          <React.Fragment key={id}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DatePicker
                minDate={
                  minDate
                    ? (filters.dateFrom as ChangeEventDatePicker)
                    : undefined
                }
                disableFuture={enableFuture ? false : true}
                onChange={(event) => setFilters(id, event)}
                value={filters[id] as ChangeEventDatePicker}
                slotProps={{
                  textField: {
                    InputProps: {
                      id: id,
                      placeholder: t(`Tablas.${label}`),
                      required: required ? true : false,
                      sx: {
                        width: `${billsSearchBar || noWrap ? "100%" : "11rem"}`,
                      },
                      // startAdornment: filters[id] && (
                      //   <IconButton
                      //     sx={{ position: "absolute", right: "2rem", backgroundColor: theme.palette.background.default }}
                      //     onClick={() => setFilters(id, null)}
                      //   >
                      //     <span className="t-icon-close" />
                      //   </IconButton>
                      // ),
                    },
                  },
                }}
              />
            </LocalizationProvider>
            {!minDate && (
              <Typography component="p" variant="body1">
                {t("Tablas.Al")}
              </Typography>
            )}
          </React.Fragment>
        ))}
      </Box>
    </FormControl>
  );
};

export default DatePickersComponent;
